import { botActionRequest } from '../../apiRequests'

export const runBot = async (inboxID) => {
    const action = {
        action: 'runBot',
        inboxID: inboxID,
        isDev: process.env.REACT_APP_SCOOP_ENV === 'dev',
    }
    return await botActionRequest(action)
}
